let body = document.getElementById('main-body');
/* Bug 5 follow-up (2026-05-04): breakpoint raised from 600 → 700 so the mobile
   menu stays active from 0–700px and the desktop menu kicks in at 701+.
   Cori reported the menu was breaking at 600 but desktop didn't take over
   until 768, leaving a broken intermediate state. Header CSS @media rules
   are also bumped 600→700 / 768→701 in styles.css and styles.header.css
   (header-only — page-content rules at 600 are intentionally unchanged). */
theme.breakpoint = 700;
function Theme_Width(b) {
  theme.height = window.innerHeight;
  // Bug 9 follow-up: defensive header lookup — fall back to body.scrollWidth
  // when header is not yet in DOM (LIVE 8.1.2 used scrollWidth unconditionally;
  // 13.1.1 stock assumes header is always present).
  var _hdr = body.querySelector('header');
  theme.width = _hdr ? _hdr.clientWidth : body.scrollWidth;
  theme.breakpoint_margin = 700 - (window.innerWidth - document.documentElement.clientWidth);
};
Theme_Width(body);
function Details_Open(b) {
  var iW = theme.width,
      dO = b.querySelectorAll('.open-container.desktop > details');
  if (iW <= theme.breakpoint_margin) {
    dO.forEach(function(d) {
      d.open = false;
    });
  } else {
    dO.forEach(function(d) {
      d.open = true;
    });
  }
};
var header = document.querySelector('header');
if(('ontouchstart' in document.documentElement) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)){
  theme.detectmob = true;
} else {
  theme.detectmob = false;
}
if (theme.detectmob) { 
  body.classList.add('true-mobile');
}
Details_Open(body);
var cW = window.innerWidth;
if (!header) {
  document.selectors = {
    sht: 0
  };
  theme.multiHead = 'false';
  window.addEventListener('resize', function(b) {  
    if (cW == window.innerWidth) {
      return;
    }
    cW = window.innerWidth;
    var body = document.body;    
    Theme_Width(body);
    Details_Open(body);
  });
  body.classList.remove('loading');
};
window.addEventListener('resize', function(b) {
  if (cW == window.innerWidth) {
    return;
  }
  cW = window.innerWidth;
  var body = document.body;
  Theme_Width(body);
  Details_Open(body);
});